import { TBreadcrumbItem } from 'components_new/molecules/Breadcrumbs'

const getTopbarBreadcrumbs = (
  entitiesLabel: string,
  entityTitle?: string
): TBreadcrumbItem[] => {
  const path: TBreadcrumbItem[] = [
    {
      href: '/entities',
      icon: { name: 'Entities' },
      title: entitiesLabel
    }
  ]

  if (entityTitle) {
    path.push({
      icon: { name: 'Entity' },
      title: entityTitle
    })
  }

  return path
}

export default getTopbarBreadcrumbs
